import { useEffect } from 'react';
import { authStore } from '../stores/authStore';
import { profileService } from '../services/profileService';

export const useProfilePhoto = () => {
  const { user, updateProfilePhoto } = authStore();

  useEffect(() => {
    const fetchProfilePhoto = async () => {
      if (user && !user.fotoPerfil) {
        try {
          const response = await profileService.getProfilePhoto();
          if (response.fotoPerfil) {
            updateProfilePhoto(response.fotoPerfil);
          }
        } catch (error) {
          console.log('Foto de perfil não disponível ou erro ao buscar');
        }
      }
    };

    fetchProfilePhoto();
  }, [user?.id]); 

  return user?.fotoPerfil;
};
